import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/build/repo/layouts/empty.vue").then(m => m.default || m)),
  "full-width": defineAsyncComponent(() => import("/opt/build/repo/layouts/fullWidth.vue").then(m => m.default || m)),
  "no-footer": defineAsyncComponent(() => import("/opt/build/repo/layouts/noFooter.vue").then(m => m.default || m))
}